import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeGTM, trackPageView } from "@/lib/gtm";

initializeGTM();
trackPageView();

window.addEventListener("popstate", () => trackPageView());
window.addEventListener("hashchange", () => trackPageView());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
